const generateFallbackPictureText = user => {
    if (!user) {
        return "A";
    }
    let text;

    const getCleanNameChunks = name => {
        if (typeof name !== "string") return name;

        // remove all unexpected chars
        let cleanName = name.replace(/[^\s\p{L}\p{N}]/giu, "");

        // remove empty entries caused by multiple spaces etc.
        const cleanNameChunks = cleanName.split(" ").filter(Boolean);

        return cleanNameChunks;
    };

    if (user.firstname && user.lastname) {
        text = user.firstname[0] + user.lastname[0];
    } else if (user.firstname) {
        text = user.firstname[0] + user.firstname[1];
    } else if (user.lastname) {
        text = user.lastname[0] + user.lastname[1];
    } else if (user.name) {
        const name = getCleanNameChunks(user.name);

        if (name.length > 1) {
            text = name[0][0] + name[1][0];
        } else {
            text = name[0][0] + (name[0][1] || "");
        }
    } else if (user.fullname) {
        const name = getCleanNameChunks(user.fullname);

        if (name.length > 1) {
            text = name[0][0] + name[1][0];
        } else {
            text = name[0][0] + name[0][1];
        }
    } else {
        text = "A";
    }

    return text.toUpperCase();
};

export default generateFallbackPictureText;
